import React from 'react';
import { Element } from 'react-scroll';

import { CustomLink } from '../../../../components/CustomLink';
import { CategoryLabel } from '../../../../components/UI/CategoryLabel';
import DifficultyIcon from '../../../../components/UI/DifficultyIcon';
import { ProgressLine } from '../../../../components/UI/ProgressLine';
import {
  Card,
  CardImg,
  CardInfo,
  CardPlayIcon,
  CardLabels,
  CardHeader,
  CardDescription,
  CardRepeatIcon,
  CardLabel,
  CardDurationInfo,
} from '../../../../components/Card';
import { createCategoryLink } from '../../../../utils/helpers';
import { DEFAULT_URL } from '../../../DiscoverPage/const';
import useStyles from './styles';
import { useTranslation } from 'react-i18next';

export const getCategories = (categories, difficulty?, withDots = true) => {
  if (!categories) return;

  const categoriesArr: React.ReactNode[] = [];

  categories.forEach((cat) => {
    const categoryLink = createCategoryLink(cat);
    categoriesArr.push(
      <CategoryLabel key={cat?.title} url={categoryLink} name={cat?.title} withDots={withDots} />,
    );
  });
  if (difficulty) {
    categoriesArr.push(<DifficultyIcon key="difficulty" difficulty={difficulty} />);
  }

  return categoriesArr;
};

const PathwayVideoCard = ({ pathway }) => {
  const { t } = useTranslation();
  const classes = useStyles(pathway?.completed)();
  const categories = getCategories(pathway?.categories, pathway?.difficulty);
  const isReactLink = !pathway?.link.includes('pricing');
  const expertLink = pathway?.userSlug ? `${DEFAULT_URL}/experts/${pathway?.userSlug}` : '';

  return (
    <Element id={pathway?.id}>
      <Card>
        <CustomLink className={classes.imageLink} link={pathway?.link} isReactLink={isReactLink}>
          <CardImg withLazyLoad wrapperClass={classes.imageWrapper} imgPath={pathway?.preview_url}>
            {pathway?.progress > 0 && <ProgressLine width={pathway?.progress} />}
            {pathway?.completed ? <CardRepeatIcon /> : <CardPlayIcon />}
          </CardImg>
          {pathway?.completed && <CardLabel>{t('page.pathway.completed')}</CardLabel>}
        </CustomLink>
        <CardInfo>
          {categories && categories.length > 0 && <CardLabels>{categories}</CardLabels>}
          {pathway?.title && (
            <CustomLink className={classes.titleWrapper} link={pathway?.link} isReactLink>
              <CardHeader text={pathway.title} />
            </CustomLink>
          )}
          {pathway?.description && <CardDescription text={pathway?.description} />}
          {(pathway?.user || pathway?.duration) && (
            <CardDurationInfo
              durationName={pathway?.user}
              duration={pathway?.duration}
              link={expertLink}
            />
          )}
        </CardInfo>
      </Card>
    </Element>
  );
};

export default PathwayVideoCard;
